<template>
  <div class="color-picker">
    <h5 v-if="heading">{{ heading }}</h5>
    <div
      class="scs-color-picker"
      :style="{
        'background-color': color,
        'z-index': pickerActive ? '3' : '',
      }"
      @click="togglePicker"
    >
      <div
        class="scs-color-picker-options"
        v-if="pickerActive"
        :style="{ [vertical]: 'calc(100% + 15px)' }"
      >
        <div
          class="scs-color-picker"
          v-for="(option, index) in options"
          :key="index"
          :style="{ 'background-color': option }"
          @click="chooseColor(option)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { preferentialVerticalProperty } from "../../../Helpers/style.js";
export default {
  data() {
    return {
      vertical: "top",
      pickerActive: false,
    };
  },
  methods: {
    togglePicker($event) {
      if (this.pickerEnabled) {
        this.vertical = preferentialVerticalProperty($event);
        this.pickerActive = !this.pickerActive;
      }
    },
    chooseColor(option) {
      this.$emit("scs-input", option);
    },
  },
  props: ["color", "pickerEnabled", "options", "heading"],
};
</script>
<style scoped>
.color-picker {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.scs-color-picker {
  width: 50px;
  height: 20px;
  margin: 5px;
  border-radius: 3px;
  filter: drop-shadow(0px 0px 1px var(--shadow));
  position: relative;
  z-index: 1;
}

.scs-color-picker:hover {
  filter: drop-shadow(0 0 4px var(--shadow));
}

.scs-color-picker-options {
  width: 250px;
  max-height: 200px;
  overflow: scroll;
  z-index: 2;
  left: calc(50% - 127.5px);
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  padding: 5px;
  flex-wrap: wrap;
  background-color: var(--backgroundColor);
  filter: drop-shadow(0 0 2px var(--shadow));
}
</style>
